import sports from './sports.js';
import art from './art.js';
import animals from './animals.js';
import space from './space.js';
import music from './music.js';
import cooking from './cooking.js';
import generic from './generic.js';
export const INTEREST_THEMES=['sports','art','animals','space','music','cooking'];
export const ROLES=['countable','measurable','container','person','action','structure','place'];
export const VOCABULARIES={generic,sports,art,animals,space,music,cooking};
export const interestFor=theme=>({basketball:'sports',football:'sports',soccer:'sports',nature:'animals'}[theme]??(INTEREST_THEMES.includes(theme)?theme:'generic'));
export function matchesSlot(word,slot){return word.role===slot.role&&(slot.tags??[]).every(tag=>(word.tags??[]).includes(tag));}
const hash=text=>[...text].reduce((n,c)=>(Math.imul(n,31)+c.charCodeAt(0))>>>0,17);
export function resolveSlots(template,theme,templateId='',vocabularies=VOCABULARIES){
 const requested=interestFor(theme),slots=Object.entries(template.slots),vocabulary=vocabularies[requested]??[];
 const themed=template.policy==='word'&&requested!=='generic'&&slots.every(([,slot])=>vocabulary.some(word=>matchesSlot(word,slot)));
 const source=themed?requested:'generic',pool=vocabularies[source]??[];
 return Object.fromEntries(slots.map(([name,slot])=>{
  const choices=pool.filter(word=>matchesSlot(word,slot));
  const word=themed?choices[hash(templateId+':'+name)%choices.length]:pool.find(word=>word.id===slot.generic&&matchesSlot(word,slot));
  if(!word)throw new Error(`Missing ${source} vocabulary for ${templateId}/${name}: ${slot.role}`);
  return [name,{word,source}];
 }));
}
